import React, { useState, useEffect } from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Select from 'react-select';
import axios from 'axios';
import { Button, Grid, Menu , Input } from 'semantic-ui-react';
import { getvendorcode,getkpidatarecon1, Fetchbankinvoicedetails,getBRSConReportFromServer,Fetchexecutequery,Fetchselectivevendordetails,Fetchbankinvoicedetails_1,Fetchselectiveerpinvoicedetails,tgetBRSReportFromServer, Fetchbankinvoicedetails1 } from '../../../services/demo/brs/vrsreport';
import * as XLSX from 'xlsx';
import excelIcon from '../../../assets/images/excel.png';
import RenderGrid from './grid';
import LoaderComponent from "../../../libraries/loader/loader";


const VerticalTabsWithAgGrid = () => {
  const [showTabs, setShowTabs] = useState(false);
  const [showicon, setShowicon] = useState(false);
  const [inputMonth, setInputMonth] = useState(undefined);

  const [link, setLink] = useState('');
  const [erpbalance, setErpBalance] = useState(false);
  const [bankbalance, setBankBalance] = useState(false);
  const [annexure1diff, setannexure1Balance] = useState(false);
  const [annexure2diff, setannexure2Balance] = useState(false);
  const [annexure3diff, setannexure3Balance] = useState(false);
  const [annexure4diff, setannexure4Balance] = useState(false);
  const [annexure5diff, setannexure5Balance] = useState(false);
  const [annexure6diff, setannexure6Balance] = useState(false);
  const [annexure7diff, setannexure7Balance] = useState(false);
  const [annexure8diff, setannexure8Balance] = useState(false);
  const [annexure9diff, setannexure9Balance] = useState(false);
  const [clientids, setclientids] = useState([]);
  const [totalcredits, settotalCredit] = useState(false);
  const [totaldebits, settotalDebit] = useState(false);
  const [totalbalan, settotalBal] = useState(false);
  const [venopenamt, setVenopen] = useState(false);
  const [intopenamt, setIntopen] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [divisionoptions, setDivisionoptions] = useState([]);
  const [entityoptions, setEntityoptions] = useState([]);
  const [accnooptions, setaccnoOptions] = useState([]);

  const [filtereddivisionoptions, setfilteredDivisionoptions] = useState([]);
  const [filteredentityoptions, setfilteredEntityoptions] = useState([]);
  const [filteredaccnooptions, setfilteredaccnoOptions] = useState([]);
  const [filteredoptions, setfilteredOptions] = useState([]);

  const [selectedaccno, setAccountno] = useState('');
  const [selecteddiv, setSelectedDivision] = useState([]);
  const [selectedentity, setEntity] = useState([]);
  const [openvarianceamt, setOpenVariance] = useState(false);
  const [clientids1, setclientids1] = useState([]);
  const [totalvar, settotalVariance] = useState(false);
  const [check, setCheck] = useState(false);
  const [recper, setReconperiod] = useState(false);  
  const [balancevariance, setVariance] = useState(false);
  const [remarkscol, setremarkscol] = useState([]);
  const [activeTab, setActiveTab] = useState('Summary');
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [selectedOption2, setSelectedOption2] = useState('');
  const [options, setOptions] = useState([]);
  const [division, setDivision] = useState([]);
  const tabNames = ['Summary','Annexure 1', 'Annexure 2','Annexure 3','Annexure 4','Annexure 5','Bank Statement','GL Records']; 
  const [tabDataMap, setTabDataMap] = useState({});
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);
  const [previousmonth1, setPreviousMonth] = useState(null);
  const [previousyear1, setPreviousYear] = useState(null);
  const [lastdate, setLastDate] = useState(null);
  const [lastdate1, setLastDate1] = useState(null);

  useEffect(() => {
    if (showTabs) {
      if (activeTab === 'Summary') {
        getKpiinfo(activeTab);
        // fetchDataForAllTabs()
      } else {
        fetchDataForTab(activeTab);
      }
    }
  }, [showTabs, activeTab]);


  const handleSearchClick = () => {
    console.log("selecteddiv",selecteddiv)
    setShowTabs(false);
    getKpiinfo('Summary');
    reportClick();
  };


  useEffect(() => {
    vrsvendorcode();
  }, []);

   useEffect(() => {
    if (inputMonth) {
      const date = new Date(inputMonth); // Input is in YYYY-MM format
      const selectedMonth = date.getMonth(); // 0-indexed
      const selectedYear = date.getFullYear();

      let previousMonth, previousYear;  // Declare variables outside of the condition

      if (selectedMonth === 0) {
          previousMonth = 12;
          previousYear = selectedYear - 1;
      } else {
          previousYear = selectedYear;
          if (selectedMonth === 1) {  // Special case for February
              previousMonth = 1;
          } else {
              previousMonth = selectedMonth;
          }
      }

      // Set month and year
      setMonth(selectedMonth + 1); // Adjust to 1-indexed
      setYear(selectedYear);
      setPreviousMonth(previousMonth); // Adjust to 1-indexed
      setPreviousYear(previousYear);



      // Calculate the last date of the month
      const lastDayOfMonth = new Date(selectedYear, selectedMonth + 1, 0);
      const formattedLastDate = `${lastDayOfMonth.getFullYear()}-${String(lastDayOfMonth.getMonth() + 1).padStart(2, '0')}-${String(lastDayOfMonth.getDate()).padStart(2, '0')}`;
      setLastDate(formattedLastDate);
      const day = String(lastDayOfMonth.getDate()).padStart(2, '0');
      const monthAbbr = date.toLocaleString('default', { month: 'short' }); // Get the month abbreviation (e.g., 'Aug')
  
      // Format the final date string as "DD-MMM-YYYY"
      const formattedDate1 = `${day}-${monthAbbr}-${selectedYear}`;
      setLastDate1(formattedDate1);

      // Log the values
      console.log('Month:', selectedMonth + 1, 'Year:', selectedYear, 'Last Date:', lastDayOfMonth);
    }
  }, [inputMonth]);

  function vrsvendorcode() {
    let payload = {
 	query: "select gl_code,gldesc,account_number,Entity,division_name from txbrs.account_master where is_active = 1 order by gl_code;"
	
    }

    var getProcessingLayerList = Fetchexecutequery();
    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(response => {
        let data = response["data"];
        console.log("data",data)
                   if (data) {
            let options = data.map((item) => {
    		return {
                  value: item.gl_code, // Use the corresponding value from table_data1
                  label: item.gl_code, // Use the corresponding label from table_data
                  entity : item.Entity,
                  division : item.division_name,
                  acct: item.account_number
                 };
            });
            let options1 = data.map((item) => {
    		return {
                  value: item.gl_code, // Use the corresponding value from table_data1
                  label: item.account_number, // Use the corresponding label from table_data
                  entity : item.Entity,
                  division : item.division_name

                 };
            });

let options2 = [...new Map(data.map(item => [item.division_name, item])).values()]
    .map(item => ({
        value: item.division_name,
        label: item.division_name,
        entity : item.Entity,
    }));
let options3 = [...new Map(data.map(item => [item.Entity, item])).values()]
    .map(item => ({
        value: item.Entity,
        label: item.Entity,
        division : item.division_name
    }));

            setOptions(options);
            setaccnoOptions(options1);
            setDivisionoptions(options2);
	    setfilteredDivisionoptions(options2);
            setEntityoptions(options3);
            setfilteredEntityoptions(options3);
	}
      })
      .catch(error => {
        console.error("Error in Processing Layer List!!!", error);
      });
  }

  const handleSelection1 = (selectedOption) => {
    setSelectedOption1(selectedOption ? selectedOption.value : '');
    setSelectedOption2(selectedOption ? selectedOption.source : '');
  };


  function reportClick(){
      setLoaderOpen(true);

      let payload = {
          "gl_code" : selectedOption.value,
          "division":selecteddiv[0]["value"],
          'month' : inputMonth,
          "previousmonth" : previousmonth1,
          "previousyear" : previousyear1

      }
      console.log("report",selecteddiv,payload,selectedOption)
      let getBrsReport = tgetBRSReportFromServer();
      axios.post(getBrsReport[1], {params : payload}, getBrsReport[0])
      .then(
          response => {
              console.log("Report Generated Response!!!", response)
              let data = response["data"];
              if (data["Status"] === "Success")
              {
                  console.log("data", data);
                  setLink(data["file"]);
                  setShowicon('True');
                  setLoaderOpen(false);
              }
              else
                console.log("Error in File Generated!!!");
		setLoaderOpen(false);
          }
      ).catch(
          error => {
              console.log("Error in File Generated!!!", error);
          }
      );

  }

  const summaryItems = [
    { description: 'Reconciliation done till', value: lastdate1 },
    { description: 'Balance as per book', value: erpbalance },
    { description: 'Balance as per bank', value: bankbalance },
    { description: 'Variance', value: balancevariance },
    { description: 'Reasons for Variance'},
    { description: 'Annexure 1 : Payment done from Bank, not accounted by Company', value: annexure3diff },
    { description: 'Annexure 2 : Receipt accounted by Company, not presented in Bank', value: annexure4diff },
    { description: 'Annexure 3 : Payment issued by Company, not presented in Bank', value: annexure1diff },
    { description: 'Annexure 4 : Amount received in Bank, not accounted by Company', value: annexure2diff },
    { description: 'Annexure 5 : Amount reconciled with value differences', value: annexure5diff },

    { description: 'Sum of total variance', value: totalvar },
    { description: 'Check', value: check },
    // Add more summary items as needed
  ];

  

  const fetchDataForAllTabs = async () => {

    try {
      const tabs = ['Annexure1','Annexure2','Annexure3','Annexure4','Annexure5','Annexure6','Annexure9'];
      const allTabData = {};
      
  
      // Loop through each tab
      for (const tab of tabs) {
        let payload;
        let fetchFunction;
        switch (tab) {
          case 'Annexure1':
            payload = {
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY = 'STD INV' and status = 'Unmatched'`
            };

            fetchFunction = Fetchexecutequery;
            
            break;
          case 'Annexure2':
            payload = {
              
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY like '%BV%' and status = 'Unmatched'`
                       };

            fetchFunction = Fetchexecutequery;
            break;

          case 'Annexure3':
            payload = {
            
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY ='CRM INV'OR DOC_CATEGORY LIKE '%TDS%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure4':
            payload = {
             
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY LIKE '%DBM%' OR DOC_CATEGORY LIKE '%DN%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure5':
            payload = {
              
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}'and credit = 0 and status = 'Unmatched' and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure6':
            payload = {
              query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and debit=0 and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          
          case 'Annexure8':
              payload = {
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and vch_type in ('Credit Note', 'Debit Note');'`
              };
              fetchFunction = Fetchexecutequery;
              break;
          case 'Annexure9':
            payload = {
              query : `SELECT * FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and status ='Contra';`,
             
            };
            fetchFunction = Fetchexecutequery;
            break;
          default:
            payload = {};
        }
  
        // Fetch data for the current tab and store it in allTabData
        const data = await fetchDataAndSetsummaryData(tab,payload, fetchFunction);
        console.log('12345',data);

        allTabData[tab] = data;
      }
  
      // Now allTabData contains the fetched data for all tabs
      console.log('Data for all tabs:', allTabData);
      // You can then assign allTabData to the parameter you want
      // For example: setParameter(allTabData);
    } catch (error) {
      console.error('Error fetching data for all tabs:', error);
    }
  };
  


  const fetchDataForTab = async (tab) => {
    try {
      let payload;

switch (tab) {
  case 'Annexure 2':
    payload = {
      query: `
        SELECT \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`,FORMAT(\`debit amt\`, 2) AS \`debit amt\`, FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\` FROM txbrs.erp AS a WHERE
        glcd = '${selectedOption.value}' AND \`division\` = '${selecteddiv[0]["value"]}' AND  \`credit amt\` = 0 AND (
          (a.match_status = 'Unmatched' AND a.glcd = '${selectedOption.value}' AND (
              STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ))
          OR 
          (a.match_id IS NOT NULL AND a.match_status IN ('Match') AND a.glcd = '${selectedOption.value}' AND (
               STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.bank AS e 
              WHERE e.match_id = a.match_id 
              AND e.gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
              AND (STR_TO_DATE(e.\`entry date\`, '%d-%b-%Y') <= '${lastdate}')
          ))
          OR 
          (a.match_id IS NOT NULL AND a.glcd = '${selectedOption.value}' 
            AND a.match_status IN ('group match', 'group unmatched', 'possible match') AND (
              STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.bank AS e 
              WHERE e.match_id = a.match_id 
              AND e.gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}' 
              AND e.match_status IN ('group match', 'group unmatched', 'possible match') 
              AND (STR_TO_DATE(e.\`entry date\`, '%d-%b-%Y') <= '${lastdate}')
          ))
          OR 
          (a.match_id IS NOT NULL AND a.match_status IN ('Contra') 
            AND a.glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}' AND (
              MONTH(STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y')) <= ${month} 
              AND YEAR(STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y')) <= ${year}
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.erp AS f 
              WHERE f.match_id = a.match_id 
              AND f.glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
              AND f.match_status IN ('Contra') 
              AND (STR_TO_DATE(f.\`gl date\`, '%d-%b-%Y') <= '${lastdate}')
              AND f.primary_id != a.primary_id
          ))
        );`
    };


          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
case 'Annexure 3':
    payload = {
      query: `
        SELECT \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`,FORMAT(\`debit amt\`, 2) AS \`debit amt\`,  FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\` FROM txbrs.erp AS a WHERE
        glcd = '${selectedOption.value}' AND \`division\` = '${selecteddiv[0]["value"]}' AND \`debit amt\` = 0 AND (
          (a.match_status = 'Unmatched' AND a.glcd = '${selectedOption.value}' AND (
              STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ))
          OR 
          (a.match_id IS NOT NULL AND a.match_status IN ('Match') AND a.glcd = '${selectedOption.value}' AND (
               STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.bank AS e 
              WHERE e.match_id = a.match_id 
              AND e.gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
              AND (STR_TO_DATE(e.\`entry date\`, '%d-%b-%Y') <= '${lastdate}')
          ))
          OR 
          (a.match_id IS NOT NULL AND a.glcd = '${selectedOption.value}' 
            AND a.match_status IN ('group match', 'group unmatched', 'possible match') AND (
              STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.bank AS e 
              WHERE e.match_id = a.match_id 
              AND e.gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
              AND e.match_status IN ('group match', 'group unmatched', 'possible match') 
              AND (STR_TO_DATE(e.\`entry date\`, '%d-%b-%Y') <= '${lastdate}')
          ))
          OR 
          (a.match_id IS NOT NULL AND a.match_status IN ('Contra') 
            AND a.glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}' AND (
              STR_TO_DATE(a.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
          ) AND NOT EXISTS (
              SELECT 1 
              FROM txbrs.erp AS f 
              WHERE f.match_id = a.match_id 
              AND f.glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
              AND f.match_status IN ('Contra') 
              AND (STR_TO_DATE(f.\`gl date\`, '%d-%b-%Y') <= '${lastdate}')
              AND f.primary_id != a.primary_id
          ))
        );`
    };


          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;

        case 'Annexure 1':
  payload = {
    query: `
     SELECT \`Value Date\`,\`Entry Date\`,\`Transaction Type\`,\`Transaction Reference\`,FORMAT(Debit,2) AS Debit,FORMAT(Credit,2) AS Credit,\`Narration\` FROM txbrs.bank AS a WHERE a.\`Credit\` = 0 and \`division\` = '${selecteddiv[0]["value"]}' AND (
    (
        a.match_status = 'Unmatched'
        AND a.gl_code = '${selectedOption.value}' 
        AND (
            MONTH(STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y')) <= ${month} 
            AND YEAR(STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y')) <= ${year}
        )
    )
    OR
    (
        a.match_id IS NOT NULL
        AND a.gl_code = '${selectedOption.value}' 
        AND a.match_status IN ('Match')
        AND STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y') <= '${lastdate}'
        AND (
            SELECT COUNT(*)
            FROM txbrs.erp AS e
            WHERE
                e.glcd = '${selectedOption.value}' 
                AND e.match_id = a.match_id
                AND (
                    STR_TO_DATE(e.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
                )
        ) = 0
    )
) 
ORDER BY STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y'), primary_id;`
  };
  await fetchDataAndSetTableData(payload, Fetchexecutequery);
  break;
  

        case 'Annexure 4':
  payload = {
    query: `
     SELECT \`Value Date\`,\`Entry Date\`,\`Transaction Type\`,\`Transaction Reference\`,FORMAT(Debit,2) AS Debit,FORMAT(Credit,2) AS Credit,\`Narration\` FROM txbrs.bank AS a WHERE a.\`debit\` = 0 and \`division\` = '${selecteddiv[0]["value"]}' and (
    (
        a.match_status = 'Unmatched'
        AND a.gl_code = '${selectedOption.value}' 
        AND (
            MONTH(STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y')) <= ${month} 
            AND YEAR(STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y')) <= ${year}
        )
    )
    OR
    (
        a.match_id IS NOT NULL
        AND a.gl_code = '${selectedOption.value}' 
        AND a.match_status IN ('Match')
        AND STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y') <= '${lastdate}'
        AND (
            SELECT COUNT(*)
            FROM txbrs.erp AS e
            WHERE
                e.glcd = '${selectedOption.value}' 
                AND e.match_id = a.match_id
                AND (
                    STR_TO_DATE(e.\`gl date\`, '%d-%b-%Y') <= '${lastdate}'
                )
        ) = 0
    )
) 
ORDER BY STR_TO_DATE(a.\`entry date\`, '%d-%b-%Y'), primary_id;`
  };
  await fetchDataAndSetTableData(payload, Fetchexecutequery);
  break;

        case 'Annexure 5':
          payload = {
            query : `WITH Filteredbank AS (
                            SELECT 
                                sum(Debit) as Debit,sum(Credit) as Credit, match_id, match_status
                            FROM 
                                txbrs.bank
                            WHERE 
                                gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
                                AND match_status != 'Contra'
                                AND STR_TO_DATE(\`entry date\`, '%d-%b-%Y') <= '${lastdate}' group by match_id, match_status

                        ),
                        Filterederp AS (
                            SELECT 
                               sum(\`debit amt\`) as \`debit amt\`,sum(\`credit amt\`) as \`credit amt\`, match_id, match_status
                            FROM 
                                txbrs.erp
                            WHERE 
                                glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
                                AND match_status != 'Contra'
                                AND STR_TO_DATE(\`gl date\`, '%d-%b-%Y') <= '${lastdate}' group by match_id, match_status
                        )
                        SELECT
                            fb.match_id,
                            fb.match_status,
                            FORMAT(SUM(fb.credit),2) AS \`Bank Credit\`,
                            FORMAT(SUM(fe.\`debit amt\`),2) AS \`Book Debit\`,
                            FORMAT(SUM(fb.debit),2) AS \`Bank Debit\`,
                            FORMAT(SUM(fe.\`credit amt\`),2)  AS \`Book Credit\`,
                            ROUND(SUM(fb.credit - fb.debit + fe.\`credit amt\` - fe.\`debit amt\`), 2) AS \`Value Difference\`
                        FROM
                            Filteredbank fb
                        JOIN
                            Filterederp fe
                            ON fb.match_id = fe.match_id 
                            AND fb.match_status = fe.match_status
                         GROUP BY
                            fb.match_id,
                            fb.match_status
                        HAVING
                            \`Value Difference\` != 0.00;`
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;


        
        case 'Bank Statement':
          payload = {
            query : `SELECT \`Value Date\`,\`Entry Date\`,\`Transaction Type\`,\`Transaction Reference\`,FORMAT(Debit,2) AS Debit,FORMAT(Credit,2) AS Credit,\`Narration\` FROM txbrs.bank 
WHERE gl_code = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}'
  AND MONTH(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${month}' 
  AND YEAR(STR_TO_DATE(\`entry date\`, '%d-%b-%Y')) = '${year}' 
ORDER BY STR_TO_DATE(\`entry date\`, '%d-%b-%Y'), primary_id;
`
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;

        case 'GL Records':
          payload = {
          query : `SELECT \`vou catg\`,\`doc catg\`,\`doc no\`,\`doc date\`,\`gl date\`,\`party code\`,\`party name\`,FORMAT(\`debit amt\`, 2) AS \`debit amt\`, FORMAT(\`credit amt\`,2) AS \`credit amt\`,\`narration\`,\`ref1\` from txbrs.erp where glcd = '${selectedOption.value}' and \`division\` = '${selecteddiv[0]["value"]}' AND MONTH(STR_TO_DATE(\`gl date\`, '%d-%b-%Y')) = '${month}'
                               and YEAR(STR_TO_DATE(\`gl date\`, '%d-%b-%Y'))= '${year}' ORDER BY STR_TO_DATE(\`gl date\`, '%d-%b-%Y'), primary_id;`, 
          };
          await fetchDataAndSetTableData(payload, Fetchexecutequery);
          break;
                
        default:
          payload = {};
          await fetchDataAndSetTableData(payload, Fetchbankinvoicedetails);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const filterOptions = (options4, selectedption) => {
        // Implement your filtering logic here
        // Example filtering logic based on selectedOption value
        if (!selectedption) {
            return options4; // Return all options if selectedOption is null or undefined
        } else {
            const filteredOptions = options4.filter(option => option.acct === selectedption.label); // Example filtering based on a property match
            return filteredOptions;
        }
    };


  function handleSelection(event) {
    console.log('event', event,accnooptions);
    const selectedValue = event;
    setSelectedOption(selectedValue);
    const filterKey = selectedValue.label;
    const filterKey1 = selectedValue.division;
    // Filter the data based on the specified key
    const filteredData = accnooptions.filter(item => item.value === filterKey && item.division === filterKey1);
    // Create a Set to track unique values
    const uniqueSet = new Set();
    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;
      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }
      return false; // Skip duplicates
    });
    setAccountno(filteredData1);
    const filteredOptions1 = divisionoptions.filter(option => option.value === selectedValue.division)
    const filteredOptions2 = entityoptions.filter(option => option.value === selectedValue.entity)
    console.log("filteredOptions1",filteredOptions1);
    setSelectedDivision(filteredOptions1);
    setEntity(filteredOptions2);

  }


  function handleSelectionaccount(event) {
    const selectedValue1 = event;
    setAccountno(selectedValue1)
    const filteredOptions5 = filterOptions(options, selectedValue1); // Implement your filtering logic
    console.log(options,selectedValue1,filteredOptions5 )
    setSelectedOption(filteredOptions5[0]);
    const filterKey1 = selectedValue1.value;
    const filterKey2 = selectedValue1.division;
    const filteredData = clientids.filter(item => item.key === filterKey1  && item.division === filterKey2);
    // Create a Set to track unique values
    const uniqueSet = new Set();
    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;
      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }
      return false; // Skip duplicates
    });
    const filteredOptions1 = divisionoptions.filter(option => option.value === selectedValue1.division)
    const filteredOptions2 = entityoptions.filter(option => option.value === selectedValue1.entity)
    console.log("divisionoptions",divisionoptions,filteredOptions1[0] );

    setclientids1(filteredData1);

    setSelectedDivision(filteredOptions1);
    setEntity(filteredOptions2);
  }

const handleSelectionEntity = (event, data) => {
    const value = data?.value || event?.value;  // Try to access `value` from data or event
    console.log("selectedValueentity", event, value);
    setEntity(event);
    const filteredOptions = options.filter(option => option.entity === value);
    const filteredOptions1 = accnooptions.filter(option => option.entity === value);
    setfilteredaccnoOptions(filteredOptions1);
    setfilteredOptions(filteredOptions);
    setAccountno('');
    setSelectedOption('');
};


const handleSelectionDivision = (event,data) => {
    const value = data?.value || event?.value;
    console.log("selectedValueentity", event,value );
    setSelectedDivision(event);
    const filteredOptions = options.filter(option => option.division === value)
    const filteredOptions1 = accnooptions.filter(option => option.division === value)
    setfilteredaccnoOptions(filteredOptions1);
    setfilteredOptions(filteredOptions);
    setAccountno('');
    setSelectedOption('');
};

useEffect(() => {
  let relatedEntities ;
  console.log("useeffect",selecteddiv,selectedentity);
  if (selecteddiv !== null && selecteddiv !== undefined) {
    relatedEntities = entityoptions.filter(option => option.division === selecteddiv.value)
  } else {
    // If no selected entities, return all bank options
    console.log("relatedEntities",selecteddiv,selectedentity);
    relatedEntities = entityoptions;
  } 
    setfilteredEntityoptions(relatedEntities);

  let relateddivision ;

  if (selectedentity !== null && selectedentity !== undefined) {
    console.log("selectedentity",selectedentity,selectedentity.value,divisionoptions);
    relateddivision = divisionoptions.filter(option => option.entity === selectedentity.value)
  } else {
    // If no selected entities, return all bank options
    relateddivision = divisionoptions;
  }
    console.log("divisionoptions",relateddivision)
    setfilteredDivisionoptions(relateddivision );

}, [selecteddiv,selectedentity]);  // Only depend on selectedEntities




  function generateColumnNames (activeTab){
    let creditColumnName, debitColumnName;
    if (activeTab === 'Bank Statement' || activeTab === 'Debited & Credited by Bank' || activeTab === 'Annexure 1' || activeTab === 'Annexure 4') {
      creditColumnName = 'Credit';
      debitColumnName = 'Debit';
    } else if (activeTab === 'Cheques & Letters OS' || activeTab === 'GL Records' || activeTab === 'Annexure 2' || activeTab === 'Annexure 3') {
      creditColumnName = 'credit amt';
      debitColumnName = 'debit amt';
    } else if (activeTab === 'Annexure2') {
      creditColumnName = 'debit';
      debitColumnName = 'INVOICE_PAYMENT_AMT';
    } else if (activeTab === 'Annexure7') {
      creditColumnName = 'ven_invoice_amount';
      debitColumnName = 'invoice_amount';
    }
    calculateTotal(creditColumnName,debitColumnName);
    // calculateTotal();
    if (activeTab === 'Annexure 5'){
    calculateTotal1(`Bank Credit`,`Bank Debit`,`Book Credit`,`Book Debit`);
    }
    return { creditColumnName, debitColumnName };
  };


// Helper function to format numbers in Indian comma system
function formatIndianNumber(number) {
  // Handle negative numbers by separating the sign
  const isNegative = number < 0;
  number = Math.abs(number);  // Get the absolute value of the number

  let [integer, decimal] = number.toString().split('.'); // Split the number into integer and decimal parts

  // If there's no decimal part, set decimal to "00" for consistent formatting
  if (!decimal) {
    decimal = "00";
  } else {
    decimal = decimal.substring(0, 2); // Limit to two decimal places
  }

  let result = '';
  let count = 0;

  // Format the integer part with Indian grouping
  // First group the last 3 digits
  for (let i = integer.length - 1; i >= 0; i--) {
    count++;
    result = integer[i] + result;
    // Add commas after every two digits except the first group of three digits
    if (count === 3 && i > 0) {
      result = ',' + result;
    } else if (count > 3 && count % 2 === 1 && i > 0) {
      result = ',' + result;
    }
  }

  // Append the decimal part
  result += '.' + decimal;

  // If the original number was negative, prepend the minus sign
  return isNegative ? '-' + result : result;
}

function calculateTotal(creditColumnName, debitColumnName) {
  let totalCredit = 0;
  let totalDebit = 0;
  let totalbal = 0;
  // Sum credits and debits
  tableData.forEach(row => {      
    const credit = creditColumnName && row[creditColumnName] ? parseFloat(row[creditColumnName].replace(/,/g, '')) : 0;
    const debit = debitColumnName && row[debitColumnName] ? parseFloat(row[debitColumnName].replace(/,/g, '')) : 0;
    totalCredit += isNaN(credit) ? 0 : credit;
    totalDebit += isNaN(debit) ? 0 : debit;
  });
  // Round the totals after calculation
  totalCredit = parseFloat(totalCredit.toFixed(2));
  totalDebit = parseFloat(totalDebit.toFixed(2));
  // Calculate balance
  totalbal = totalCredit - totalDebit;
  totalbal = parseFloat(totalbal.toFixed(2));
  // Set the final rounded totals (in Indian format)
  settotalCredit(formatIndianNumber(totalCredit));
  settotalDebit(formatIndianNumber(totalDebit));
  settotalBal(formatIndianNumber(totalbal));
  // Return the totals
  return { totalCredit: formatIndianNumber(totalCredit), totalDebit: formatIndianNumber(totalDebit) };
}


function calculateTotal1(bankcreditColumnName, bankdebitColumnName, bookcreditColumnName, bookdebitColumnName) {
    let totalBankCredit = 0;
    let totalBankDebit = 0;
    let totalBookCredit = 0;
    let totalBookDebit = 0;
    let totalCredit = 0;
    let totalDebit = 0;
    let totalBal = 0;
    
    settotalCredit(totalCredit);
    settotalDebit(totalDebit);
    settotalBal(totalBal);
    tableData.forEach(row => {
    const BankCredit = bankcreditColumnName && row[bankcreditColumnName] ? parseFloat(row[bankcreditColumnName].replace(/,/g, '')) : 0;
    const BankDebit = bankdebitColumnName && row[bankdebitColumnName] ? parseFloat(row[bankdebitColumnName].replace(/,/g, '')) : 0;
    const BookCredit = bookcreditColumnName && row[bookcreditColumnName] ? parseFloat(row[bookcreditColumnName].replace(/,/g, '')) : 0;
    const BookDebit = bookdebitColumnName && row[bookdebitColumnName] ? parseFloat(row[bookdebitColumnName].replace(/,/g, '')) : 0;

    totalBankCredit += isNaN(BankCredit) ? 0 : BankCredit;
    totalBankDebit += isNaN(BankDebit) ? 0 : BankDebit;
    totalBookCredit += isNaN(BookCredit) ? 0 : BookCredit;
    totalBookDebit += isNaN(BookDebit) ? 0 : BookDebit;
        // Calculate total credit and debit
        totalCredit = totalBankCredit + totalBookCredit;
        totalDebit = totalBankDebit + totalBookDebit;
        
        // Calculate balance
        totalBal = totalBankCredit + totalBookCredit - totalBankDebit - totalBookDebit;
        
        // Round to two decimal places
        totalCredit = parseFloat(totalCredit.toFixed(2));
        totalDebit = parseFloat(totalDebit.toFixed(2));
        totalBal = parseFloat(totalBal.toFixed(2));
        
        // Set the totals
  console.log('annexure5',totalCredit,totalDebit,totalBal)
  settotalCredit(formatIndianNumber(totalCredit));
  settotalDebit(formatIndianNumber(totalDebit));
  settotalBal(formatIndianNumber(totalBal));
    });
    
    return { totalCredit, totalDebit };
}


  function getKpiinfo(event) {
    let payload = {
      "table" : selectedOption,
      'accpacid' : selectedOption1,
      'month' : inputMonth,
      'lastdate' : lastdate
    };
  
    console.log('payload status', payload,selectedOption);
  
    var getProcessingLayerDataWithStatus = getkpidatarecon1();
  
    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(response => {
        console.log("Processing Layer Data With Status with chart data----!!!", response);
        let data = response["data"];
        let annexure1 = data["annexure1total"];
        let annexure2 = data["annexure2total"];
        let annexure3 = data["annexure3total"];
        let annexure4 = data["annexure4total"];
        let annexure5 = data["annexure5total"];
        let erpclosingbalance = data["erpclosingbalance"];
        console.log("erpclosingbalance",erpclosingbalance)
        let bankclosingbalance = data["bankclosingbalance"];
        let balancevariance = data["balancevariance"];
        let lastdate = data["lastdate"];
        let annexure9 = data["annexure9total"];
        let intopen = data["intopen"];
        let venopen = data["venopen"];
        let openvariance = data["openvariance"];
        let totalvariance = data["totalvariance"];
  
        // Assuming closingperiod is an array of objects
  
        let annexure1total = annexure1 ? parseFloat(annexure1.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure2total = annexure2 ? parseFloat(annexure2.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure3total = annexure3 ? parseFloat(annexure3.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure4total = annexure4 ? parseFloat(annexure4.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";        
        let annexure5total = annexure5 ? parseFloat(annexure5.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";        

        // Get total variance and ensure it's a number with fixed decimal places
        let variancetotal1 = totalvariance ? parseFloat(totalvariance.total_amount) : 0;
        let bankclosingbalance1 = bankclosingbalance ? parseFloat(bankclosingbalance.bank_closing_balance) : 0;
        let erpclosingbalance1 = erpclosingbalance ? parseFloat(erpclosingbalance.erp_closing_balance) : 0;
        // Calculate the sum

        let balancevariance1 = erpclosingbalance1 - bankclosingbalance1;
        console.log('Balance Variance:', balancevariance1);
        let check = balancevariance1 + variancetotal1;
        let balancevariance2 = balancevariance1 ? parseFloat(balancevariance1).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        console.log('Balance Variance2:', balancevariance2);
        // Format the result for display
        let formattedCheck = check.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        let formattedbalvariance = check.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        variancetotal1 = totalvariance ? parseFloat(totalvariance.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        erpclosingbalance1 = erpclosingbalance ? parseFloat(erpclosingbalance.erp_closing_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        bankclosingbalance1 = bankclosingbalance ? parseFloat(bankclosingbalance.bank_closing_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";


        console.log('check',balancevariance1,variancetotal1, formattedCheck);
        
        setannexure1Balance(annexure1total);
        setannexure2Balance(annexure2total);
        setannexure3Balance(annexure3total);
        setannexure4Balance(annexure4total);
        setannexure5Balance(annexure5total);
        settotalVariance(variancetotal1);
        setErpBalance(erpclosingbalance1);
        setBankBalance(bankclosingbalance1);
        setVariance(balancevariance2);
        setCheck(formattedbalvariance);
        setShowTabs(true);
  
      })
      .catch(error => {
        console.log("Error in Processing Layer Data WIth Status!!!", error);
      });
  }
  


  const fetchDataAndSetsummaryData = async (tab,payload, fetchFunction) => {
    try {
        var FileUploadCredentials = fetchFunction();
        console.log('tab',tab)

        const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        const tableData = response.data;
        
        // Generate column definitions
        let remarkscol = [];
        let columnDefs = [];

        // Check if tableData has elements
        if (tableData.length > 0) {
            // Get the keys (column names) of the first object in tableData
            const columnNames = Object.keys(tableData[0]);

            // Create column definitions based on columnNames
        //     remarkscol = columnNames.map((columnName) => ({
        //         headerName: columnName, // Use column name as header
        //         field: columnName, // Use column name as field
        //     }));
        // }

        columnDefs = columnNames.map((columnName) => ({
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
      }));
  }


        return tableData;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};

const fetchDataAndSetTableData = async (payload, fetchFunction) => {
  try {
    setTableData([]); 
    setremarkscol([]);

    var FileUploadCredentials = fetchFunction();
    const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
    const tableData = response.data;

    // Generate column definitions
    let remarkscol = [];
    let columnDefs = [];

    // Check if tableData has elements
    if (tableData.length > 0) {
      // Get the keys (column names) of the first object in tableData
      const columnNames = Object.keys(tableData[0]);

      columnDefs = columnNames.map((columnName) => {
        // Check if the column is 'credit' or 'debit' for right alignment
        const isCreditOrDebit = columnName.toLowerCase() === 'credit amt' || columnName.toLowerCase() === 'debit amt' || columnName.toLowerCase() === 'credit' || columnName.toLowerCase() === 'debit';

        return {
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
          // Apply right alignment for 'credit' or 'debit' columns
          cellStyle: isCreditOrDebit ? { textAlign: 'right' } : {}
        };
      });
    }

    setTableData(tableData);
    setremarkscol(columnDefs);
    return tableData;
  } catch (error) {
    console.error('Error in POST request:', error);
    throw error;
  }
};


  const handleTabChange = (e, { name }) => {
    setActiveTab(name);
    generateColumnNames(activeTab);
  };
  useEffect(() => {
    if (activeTab) {
      generateColumnNames(activeTab);
    }
  });

  

  return (
    <div className="custom-layout">
      <div style={{ paddingLeft: '20px' }}>
        <Grid>
          <Grid.Row>
            <Grid.Column style={{ width: '15%' }}>
              <div className="file-upload-card">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Month</label> <br />
                        <Input type="month" className="cardName filetype" style={{ paddingLeft: "10px" }} onChange={(e) => { setInputMonth(e.target.value) }} id="file-upload-month" />
                </div>
            </Grid.Column>
          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group2">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Entity Name</label> <br />
              <div className="reconsummary">
                <Select
                  isClearable={true}
                  options={filteredentityoptions}
                  selection
                  size='mini'
                  onChange={handleSelectionEntity}
                  value={selectedentity}
                  style={{ backgroundColor: 'white' }}
                />
              </div>
            </div>
          </Grid.Column>

          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group2">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Division Name</label> <br />
              <div className="reconsummary">
                <Select
                  isClearable={true}
                  options={filtereddivisionoptions}
                  selection
                  size='mini'
                  onChange={handleSelectionDivision}
                  value={selecteddiv}
                  style={{ backgroundColor: 'white' }}
                />
              </div>
            </div>
          </Grid.Column>

            <Grid.Column style={{ width: '15%' }}>
              <div className="form-group2">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>GL Code</label> <br />
                <Select
                  options={filteredoptions?.length ? filteredoptions : options}
                  onChange={handleSelection}
                  value={selectedOption}
                  styles={{ container: (provided) => ({ ...provided, width: '100%' }) }}
                />
              </div>
            </Grid.Column>


          <Grid.Column style = {{ width : "200px"}}>
            <div className="form-group2">
              <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Account Number</label> <br />
              <div className="reconsummary">
                <Select
                  clearable
                  options={filteredaccnooptions?.length ? filteredaccnooptions : accnooptions}
                  selection
                  size='mini'
                  onChange={handleSelectionaccount}
                  value={selectedaccno}
                  style={{ backgroundColor: 'white' }}
                />
              </div>
            </div>
          </Grid.Column>

            <Grid.Column style={{ width: '100px'}}>
              <br></br>
              <div style={{ marginTop: '10px' }}>
                <Button primary style={{ padding: '8px 12px', fontSize: '14px' }} onClick={handleSearchClick}>
                  Search
                </Button>
              </div>
            </Grid.Column>
            <Grid.Column style={{ width: '100px',paddingTop:  '3px',alignContent: 'end' }}>
            <div>
           {showicon === 'True' && (
  <a href={link}>
    <img
      src={excelIcon}
      alt="No Images"
      style={{ width: '40px', height: '37px' }}
      className="excel-icon-class"
      title="Export"
    />
  </a>
)}

                    </div>
            
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      {showTabs && (
        <div className="content-container" style={{ padding: '25px' }}>
          
          <Grid columns={2} stackable>
  <Grid.Column width={3}>
    <Menu pointing vertical fluid>
      {tabNames.map((tabName) => (
        <Menu.Item
          key={tabName}
          name={tabName}
          active={activeTab === tabName}
          onClick={handleTabChange}
        >
          {tabName === 'Summary' ? 'Summary' : tabName.charAt(0).toUpperCase() + tabName.slice(1)}
        </Menu.Item>
      ))}
    </Menu>
  </Grid.Column>
  <Grid.Column width={13}>
  <Grid.Row>
    
  </Grid.Row>

  <Grid.Row style = {{paddingLeft : '30px'}}>
    <div className="ag-theme-balham report-layer" style={{ overflow: 'hidden', width: '80%'}}>
      {activeTab === 'Summary' ? (
        <div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
  {summaryItems.map((item, index) => (
    <div key={index} style={{ borderBottom: '1px solid #ddd', padding: '12px', display: 'flex' }}>
      <div style={{ flex: '65%', textAlign: 'left',width: '50px', marginRight: '10px' }}>{item.description}</div>
      <div style={{  marginRight: '10px' }}>:</div>
      <div style={{ flex: '2', textAlign: 'right' }}>{item.value}</div>
    </div>
  ))}
</div>


        </div>
      ) : (

        <div>
        {/* Display multiple totals above the grid table */}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}>{activeTab === 'Annexure 5' ? 'Book:' : 'Debit:'}</div>
          <div style={{ paddingRight: '40px', fontWeight: 'bold', fontSize: '1.2em' }}>{totaldebits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}>{activeTab === 'Annexure 5' ? 'Bank:' : 'Credit:'} </div>
          <div style={{ paddingRight: '40px',fontWeight: 'bold', fontSize: '1.2em' }}>{totalcredits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}> Total:</div>
          <div style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{totalbalan}</div>
        </div>
        
        <div className="ag-theme-alpine"
            style={{ width: '100%' }}
          >
        
         <AgGridReact
        animateRows={true}
        rowData={tableData}
        columnDefs={remarkscol.map(column => ({ ...column, width: 150, resizable: true  }))}
        rowHeight={30}
        pagination={true}
        paginationPageSize={10}
        groupSelectsChildren={true}
        enableFilter={true}
        enableSorting={true}
        enableServerSideSorting={true}
        enableServerSideFilter={true}
        suppressRowClickSelection={true}
        suppressAggAtRootLevel={true}
        domLayout='autoHeight'
      >
         </AgGridReact>
      </div>
      </div>
      )}
      
      
    </div>
    </Grid.Row>
  </Grid.Column>
</Grid>

        </div>
      )}
            <LoaderComponent loaderOpen={loaderOpen} />

    </div>
  );
};

export default VerticalTabsWithAgGrid;



